import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, Menu, Paper, IconButton, Modal, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonEditButton, CommonGridToolBarWithExtraFilter, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { CurrencySymbol, gstPercentageConfig } from '../../../Utility/Constants'
import moment from 'moment';
import { TimePicker as AntdTimePicker } from 'antd';
import { AddCircle, ExpandMore, FormatShapes, Sort } from '@material-ui/icons';
import { localGetItem } from '../../../Utility/Services/CacheProviderService'
import Loader from '../../../Components/Loader'
import { ImagePaths } from '../../../Utility/ImagePaths'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { AmountFormat, CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'

const fieldLimits = {
    serviceSearchHeadCode: 10,
    serviceSearchHead: 100,
    serviceSearchCode: 10,
    serviceSearchName: 100,
    serviceLabHeadCode: null,
    serviceLabHead: null,
    serviceLabCode: null,
    serviceLabName: null,
    serviceCharge: 10,
    doctorShareRupee: 10,
    doctorSharePercent: 10,
    hospitalShareRupee: 10,
    hospitalSharePercent: 10,
    intervalAmount: 10,
};

const patient_type = ['All', 'New Patient', 'Review Patient', 'Old Patient']
const IntervalList = Array.from({ length: 60 }, (_, i) => (i + 1).toString());
var NumberList = []
for (var i = 1; i < 100; i++) { NumberList.push(i); }

export default function DepartmentMaster() {
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Service Master", "SubTab")?.editAccess
    const [departmentData, setdepartmentData] = useState([]);
    const [doctorList, setdoctorList] = useState([]);
    const [wardList, setwardList] = useState([]);
    const [filteredServiceList, setFilteredServiceList] = useState(null);
    const [filterdepartment, setFilterDepartment] = useState('');
    const [filterHead, setFilterHead] = useState(null);
    const [filterName, setFilterName] = useState(null);
    const [moduleList, setModuleList] = useState([]);
    const [HeaderList, setHeaderList] = useState([]);
    const [ServiceList, setServiceList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [deptListState, setDeptListState] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [submitAction, setSubmitAction] = useState('no');
    const [submitFlag, setSubmitFlag] = useState({});
    const [submitMessage, setSubmitMessage] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);
    const [linkedModule, setlinkedModule] = useState([]);
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [formState, setFormState] = useState({
        page: 0,
        pageSize: 10,
        department: null,
        serviceHeadCode: null,
        serviceHead: null,
        serviceCode: null,
        serviceName: null,
        serviceHeadId: null,
        serviceNameId: null,
        serviceLabHeadCode: null,
        serviceLabHead: null,
        serviceLabCode: null,
        serviceLabName: null,
        serviceSearchHeadCode: '',
        serviceSearchHead: '',
        serviceSearchCode: '',
        serviceSearchName: '',
        serviceHeadCodeData: [],
        serviceHeadData: [],
        serviceCodeData: [],
        serviceNameData: [],
        patientType: 'All',
        selectedDoctorId: null,
        selectedWardId: null,
        serviceCharge: '',
        selectedUnitValue: 1,
        selectedDaysCount: '',
        selectedUnit: 'Nos',
        selectedTime: null,
        doctorShareRupee: '',
        doctorSharePercent: '',
        doctorSharePercentFull: '',
        hospitalShareRupee: '',
        hospitalSharePercent: '',
        hospitalSharePercentFull: '',
        intervalTime: null,
        intervalAmount: 0,
        is_gst_enabled: JSON.parse(localGetItem("is_gst_enabled")),
        gstPercentage: '',
        reviewDays: "",
        reviewCount: "",
        serviceLabTestId: null,
        serviceLabGrpId: null,
        isHospital: false,
        serviceLabDeptId: null,
        serviceLabHeadId: null,
        serviceLabDetailId: null,
        additionalDetailId: null,
        additionalHeadId: null,
    });
    const [filteredTestCodes, setFilteredTestCodes] = useState([]);
    const [filteredGroupTestDetails, setFilteredGroupTestDetails] = useState([]);
    const [deptNamesState, setDeptNamesState] = useState([]);
    const [deptCodesState, setDeptCodesState] = useState([]);
    const [groupTestDetailsState, setGroupTestDetailsState] = useState([]);
    const [headConsultData, setheadConsultData] = useState([])
    const [testCodesState, setTestCodesState] = useState([]);
    const [consultation, setConsultation] = useState(false);
    const [Sharable, setSharable] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editUnit, seteditUnit] = useState(true);
    const [editAmount, seteditAmount] = useState(true);
    const [editDiscount, seteditDiscount] = useState(true);
    const [activeByHead, setactiveByHead] = useState(true);
    const [activeByName, setactiveByName] = useState(true);
    const [activeByCharge, setactiveByCharge] = useState(true);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [delHeadIDs, setDelHeadIDs] = useState([]);
    const [delServiceIDs, setDelServiceIDs] = useState([]);
    const [delChargeIDs, setDelChargeIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [deleteMethod, setDeleteMethod] = useState('');
    const [enableHead, setenableHead] = useState(false)
    const [enableService, setenableService] = useState(false)
    const [enableOthers, setenableOthers] = useState(false)
    const [disbleServiceBasedEdit, setdisbleServiceBasedEdit] = useState(false)
    const [disableDoc, setdisableDoc] = useState(false)
    const [InvestigationList, setInvestigationList] = useState([])
    const [TherapyMaster, setTherapyMaster] = useState([])
    const [TherapyTecniques, setTherapyTecniques] = useState([])
    const [isMobileService, setisMobileService] = useState(false)
    const [formResetKey, setFormResetKey] = useState(0)
    const UserData = JSON.parse(localGetItem('loggedInUserInfo'))

    useEffect(() => {
        getDoctorList();
        getWardList();
        setInvestigationList(localGetItem("Investigation_List") ? JSON.parse(localGetItem("Investigation_List")) : [])
        GetTherapyMasters()
        GetTherapyTechnics()
    }, [])

    useEffect(() => {
        getModuleList();
        if (formState?.department === "LAB") {
            getLabDatas();
        }
    }, [formState?.department])

    useEffect(() => {
        getDepartmentData();
    }, [filterdepartment, filterHead, filterName])

    useEffect(() => {
        if (consultation && !EditID) {
            getHeadCounsultationList();
        }
    }, [consultation]);

    const getLabDatas = () => {
        try {
            setisloader(true);
            RestAPIService.getAll(Serviceurls.FO_LAB_SEARCH)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const apiData = response.data.data[0]?.LAB || [];
                        if (apiData && Array.isArray(apiData)) {
                            const deptNames = apiData.map(dept => dept?.dept_name);
                            const deptCodes = apiData.map(dept => dept?.dept_code);


                            setDeptListState(apiData)
                            setDeptNamesState(deptNames);
                            setDeptCodesState(deptCodes);
                        }
                        setisloader(false);
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                        setisloader(false);
                    } else {
                        errorMessage(error.message)
                        setisloader(false);
                    }
                })
        } catch (error) {
            errorMessage(error.message)
            setisloader(false);
        }
    }

    const getModuleList = () => {
        try {
            RestAPIService.getAll(Serviceurls.MODULE_LIST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const ModuleData = response.data.data || [];
                        setOriginalList(ModuleData);
                        setModuleList(Object.keys(ModuleData));
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message);
                    } else {
                        errorMessage(error.message);
                    }
                });
        } catch (error) {
            errorMessage(error.message);
        }
    };

    const GetTherapyTechnics = () => {
        try {
            RestAPIService.getAll(Serviceurls.TREATMENT_TECHNIQUE_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const filteredData = response?.data?.data?.filter(item => item.is_active);
                        setTherapyTecniques(filteredData || [])
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const GetTherapyMasters = () => {
        try {
            RestAPIService.getAll(Serviceurls.RADIO_THERAPY_GET)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const filteredData = response?.data?.data?.filter(item => item.is_active);
                        setTherapyMaster(filteredData || [])
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const doctorData = response.data.data || [];
                        const updatedDoctorList = [{ doctor_id: null, doctor_name: 'All' }, ...doctorData];
                        setdoctorList(updatedDoctorList);

                        setFormState((prevState) => ({
                            ...prevState,
                            selectedDoctorId: updatedDoctorList[0],
                        }));
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getWardList = () => {
        RestAPIService.getAll(Serviceurls.BED_CONFIG)
            .then((response) => {
                if (response?.data?.status === "success") {
                    const BedData = response?.data?.data || [];

                    if (BedData?.length > 0) {
                        const uniqueWardList = Array.from(
                            new Map(
                                BedData.map(item => [item?.ward_id, {
                                    ward_id: item?.ward_id,
                                    ward_name: item?.ward__ward_name
                                }])
                            ).values()
                        );

                        const updatedWardList = [{ ward_id: null, ward_name: 'All' }, ...uniqueWardList];
                        setwardList(updatedWardList);
                        setFormState((prevState) => ({
                            ...prevState,
                            selectedWardId: updatedWardList[0],
                        }));
                    }
                } else {
                    errorMessage(response?.data?.message);
                }
            })
            .catch((error) => {
                errorMessage(error.message);
            });
    };

    const getDepartmentData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_DEPARTMENT_MASTER + `?module_type=${filterdepartment ? encodeURIComponent(filterdepartment) : ""}&service_head_id=${""}&service_details_id=${""}&service_head=${(filterHead?.head_name) ? encodeURIComponent(filterHead?.head_name) : ""}&service_name=${(filterName?.service_name) ? encodeURIComponent(filterName?.service_name) : ""}&service_head_code=${""}&charge_type=Normal`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setdepartmentData(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDeleteOption = (option) => {
        setDeleteMethod(option)
        setisDelete(true)
        setAnchorEl(null);
    };

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const updateServiceLabData = (key, val) => {
        // const isCode = key === 'serviceLabHeadCode';
        const selectedDept = deptListState.find(dept => (dept.dept_name === val));
        return {
            serviceLabHeadCode: selectedDept?.service_head_code || '',
            serviceLabHead: selectedDept?.dept_name || '',
            serviceLabName: null,
            serviceLabCode: '',
            serviceLabHeadId: selectedDept?.id || null,
            serviceLabDeptId: selectedDept?.dept_id,
            filteredGroupTestDetails: selectedDept?.service_details?.map(item => ({
                grp_name: item.grp_name || "",
                test_name: item.test_name || "",
                service_details_id: item.id,
                service_code: item.service_code,
                grp_id: item.grp_id || null,
                test_id: item.test_id || null,
                is_hospital: item.is_hospital || false,
                is_sharable: item.is_sharable || false,
            })) || groupTestDetailsState,

            filteredTestCodes: selectedDept?.service_details?.map(item => item.service_code).filter(Boolean) || testCodesState
        };
    };

    const checkServiceSharable = (selectedModule, selectedServiceId, moduleList) => {
        if (!selectedModule || !selectedServiceId || !moduleList) return;

        // Get the module's data
        const moduleData = moduleList[selectedModule];

        if (!moduleData || moduleData.length === 0) {
            setSharable(false);
            return;
        }

        let isSharable = false;

        moduleData.forEach((head) => {
            if (head.service_details && head.service_details.length > 0) {
                // Find the selected service
                const selectedService = head.service_details.find(service => service.id === selectedServiceId);

                if (selectedService) {
                    isSharable = selectedService.is_sharable;
                }
            }
        });

        setSharable(isSharable);
    };

    const onChangeAuto = (e, val, name) => {
        // if (!val) return;

        let updatedState = { ...formState };

        let sharableId = updatedState?.serviceHead?.service_details?.[0].id

        checkServiceSharable(name === 'department' ? val : '', sharableId, moduleList)

        
        switch (name) {
            case 'department':
                if (!val) {
                    clearFunction()
                    break;
                } else {
                    let HeadList = originalList[val] || [];
                    
                    let isRadiotherapy = (val === "RADIOTHERAPY")
                    let uniqueHeadList = []
                    if (isRadiotherapy) {
                        uniqueHeadList = TherapyMaster?.map((item) => {
                            return {
                                service_head_code: item?.therapy_code,
                                head_name: item?.therapy_name,
                            }
                        })
                    } else {
                        uniqueHeadList = HeadList.reduce((acc, current) => {
                            if (!acc.find(item => item.service_head_code === current.service_head_code)) {
                                acc.push(current);
                            }
                            return acc;
                        }, []);
                    }

                    setConsultation(false)
                    setSharable(false)
                    setenableHead(true)
                    setenableService(false)
                    setenableOthers(false)
                    setdisbleServiceBasedEdit(false)
                    updatedState = {
                        ...updatedState,
                        department: val,
                        serviceHeadCodeData: uniqueHeadList,
                        serviceHeadData: uniqueHeadList,
                        serviceCodeData: [],
                        serviceNameData: [],
                        // selectedWardId: ((val === "IP" || val === "IP_OP") && wardList.length > 0) ? wardList[0] : null,
                        selectedWardId: wardList.length > 0 ? wardList[0] : null,
                        patientType: 'All',
                        selectedDoctorId: doctorList.length > 0 ? doctorList[0] : null,
                        serviceHeadCode: null,
                        serviceHead: null,
                        serviceCode: null,
                        serviceName: null,
                        serviceHeadId: null,
                        serviceNameId: null,
                        serviceLabName: null,
                        serviceLabCode: null,
                        serviceLabHead: null,
                        serviceLabHeadCode: null,
                        serviceSearchHeadCode: '',
                        serviceSearchHead: '',
                        serviceSearchCode: '',
                        serviceSearchName: '',
                        serviceLabHeadId: null,
                        serviceLabDeptId: null,
                        serviceLabTestId: null,
                        serviceLabDetailId: null,
                        serviceLabGrpId: null,
                        serviceCharge: '',
                        selectedUnitValue: 1,
                        selectedDaysCount: '',
                        selectedUnit: 'Nos',
                        selectedTime: null,
                        doctorShareRupee: '',
                        doctorSharePercent: '',
                        doctorSharePercentFull: '',
                        hospitalShareRupee: '',
                        hospitalSharePercent: '',
                        hospitalSharePercentFull: '',
                        intervalTime: null,
                        intervalAmount: 0,
                        gstPercentage: '',
                        reviewDays: "",
                        reviewCount: "",
                        additionalDetailId: null,
                        additionalHeadId: null,
                    };
                    break;
                }
            case 'selectedDoctorId':
            case 'selectedWardId':
            case 'intervalTime':
                updatedState = { ...updatedState, [name]: val };
                break;

            case 'serviceSearchHeadCode':
                if (!val) {
                    clearFunction('head')
                    break;
                } else {
                    setenableService(true)
                    let ServiceDetails = val?.service_details
                    if(formState?.department === "RADIOTHERAPY"){
                        ServiceDetails = TherapyTecniques?.map((item) => {
                            return {
                                service_code: item?.therapy_technique_code,
                                service_name: item?.therapy_technique_name,
                            }
                        })
                    }
                    updatedState = {
                        ...updatedState,
                        serviceHead: val,
                        serviceHeadCode: val,
                        serviceCodeData: ServiceDetails,
                        serviceNameData: ServiceDetails,

                    };
                    break;
                }
            case 'serviceSearchHead':
                if (!val) {
                    clearFunction('head')
                    break;
                } else {
                    let ServiceDetails = val?.service_details
                    if(formState?.department === "RADIOTHERAPY"){
                        ServiceDetails = TherapyTecniques?.map((item) => {
                            return {
                                service_code: item?.therapy_technique_code,
                                service_name: item?.therapy_technique_name,
                            }
                        })
                    }
                    setenableService(true)
                    val?.id && setConsultation(val?.is_consultation)
                    val?.id && setactiveByHead(val?.is_active)
                    !(val?.is_active) && setactiveByName(false)
                    !(val?.is_active) && setactiveByCharge(false)
                    val?.id && setisMobileService(val?.is_mobile_service)
                    !(val?.is_consultation) && setdisableDoc(false)
                    setenableOthers(false)
                    updatedState = {
                        ...updatedState,
                        serviceHead: val,
                        serviceHeadCode: typeof (val) == "object" ? val : null,
                        serviceCodeData: ServiceDetails,
                        serviceNameData: ServiceDetails,
                        serviceHeadId: null,
                        serviceNameId: null,
                        serviceCode: null,
                        serviceName: null,
                        // selectedDoctorId: null,
                        selectedDoctorId: doctorList.length > 0 ? doctorList[0] : null,
                    };
                    break;
                }
            case 'serviceSearchCode':
                if (!val) {
                    clearFunction('service')
                    break;
                } else {
                    setenableOthers(true)
                    updatedState = {
                        ...updatedState,
                        serviceCode: val,
                        serviceName: val,
                        serviceNameId: null,
                        [name]: ''
                    };
                    break;
                }
            case 'serviceSearchName':
                if (!val) {
                    clearFunction('service')
                    break;
                } else {
                    setenableOthers(true)
                    val?.id && setactiveByName(val?.is_active)
                    val?.id && setactiveByCharge(val?.is_active)
                    // val?.id && seteditUnit(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : val?.edit_unit)
                    // val?.id && seteditAmount(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : val?.edit_amount)
                    // val?.id && seteditDiscount(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : val?.edit_discount)
                    val?.id && setSharable(val?.is_sharable)
                    updatedState = {
                        ...updatedState,
                        serviceCode: typeof (val) == "object" ? val : null,
                        serviceName: val,
                        gstPercentage: val?.id ? val?.gst_percent : '',
                        isHospital: val?.id ? val?.is_hospital : false,
                        selectedUnit: val?.id ? val?.unit_type : 'Nos',
                        selectedTime: (val?.id && val?.unit_type === 'Hrs') ? val?.unit : null,
                        serviceNameId: null,
                        [name]: ''
                    };
                    break;
                }
            case 'serviceConsultant':
                if (!val) {
                    return;
                } else {
                    let selectedDoctor = null
                    if (val?.doctor_id) {
                        selectedDoctor = doctorList.filter(item => item.doctor_id == val?.doctor_id)
                    }
                    selectedDoctor && setdisableDoc(true)
                    setenableOthers(true)
                    updatedState = {
                        ...updatedState,
                        serviceName: typeof (val) == "object" ? val.doctor_name : '',
                        serviceNameId: typeof (val) == "object" ? val.id : null,
                        serviceCode: typeof (val) == "object" ? val.service_code : '',
                        selectedDoctorId: selectedDoctor.length > 0 ? selectedDoctor[0] : null
                    }
                    break;
                }
            case 'serviceLabHeadCode':
            case 'serviceLabHead': {
                const updatedData = updateServiceLabData(name, val);
                updatedState = { ...updatedState, ...updatedData };
                setGroupTestDetailsState(updatedData?.filteredGroupTestDetails?.length > 0 ? updatedData?.filteredGroupTestDetails : []);
                setTestCodesState(updatedData?.filteredTestCodes?.length > 0 ? updatedData?.filteredTestCodes : []);
                setenableService(true)
                break;
            }

            default:
                if (formState?.department === "LAB" && name !== "serviceLabHeadCode" && name !== 'serviceLabHead') {
                    let selectedTestName = null;
                    let selectedGroupName = null;
                    let selectedTestCode = null;
                    let selectedGroupCode = null;
                    // let selectedDeptForTest = null;
                    let selectedTestId = null;
                    let selectedGrpId = null;
                    let selectedDetailId = null;

                    const selectedGroupTest = groupTestDetailsState.find(({ grp_id, test_id }) =>
                        (test_id && (val?.test_id === test_id)) || (grp_id && (val?.grp_id === grp_id))
                    );

                    if (selectedGroupTest) {
                        selectedTestName = selectedGroupTest?.test_name;
                        selectedGroupName = selectedGroupTest?.grp_name;
                    }

                    const matchingTest = deptListState
                        .flatMap(dept => {
                            if (dept.dept_id === formState?.serviceLabDeptId) {
                                return dept.service_details || [];
                            }
                            return []
                        }).find(test => {
                            if (test?.test_id && test?.test_id === val?.test_id && !test.grp_id) return true;
                            if (test?.grp_id && test?.grp_id === val?.grp_id && !test.test_id) return true;
                            if (test?.service_code && test.service_code === val) return true;
                            if (test?.test_name && test.test_name === selectedTestName && !test.grp_name) return true;
                            if (test?.grp_name && test.grp_name === selectedGroupName && !test.test_name) return true;
                            if (test?.test_name && test.test_name === selectedTestName && test?.grp_name && test.grp_name === selectedGroupName) return true;
                            if (test?.grp_service_code && test.grp_service_code === val) return true;
                        });

                    if (matchingTest) {
                        selectedTestCode = matchingTest.service_code;
                        selectedTestName = matchingTest.test_name;
                        selectedGroupName = matchingTest.grp_name;
                        selectedGroupCode = matchingTest.grp_service_code;
                        selectedTestId = matchingTest.test_id;
                        selectedGrpId = matchingTest.grp_id;
                        selectedDetailId = matchingTest.id || null;
                    }

                    // selectedDeptForTest = deptListState.find(dept =>
                    //     dept.service_details?.some(test => {
                    //         return (test?.test_name && test?.test_name === selectedTestName) ||
                    //             (test?.service_code && test?.service_code === selectedTestCode) ||
                    //             (test?.grp_name && test?.grp_name === selectedGroupName);
                    //     })
                    // );

                    updatedState = {
                        ...updatedState,
                        serviceLabName: name === 'serviceLabName' ? val : (selectedGroupName && selectedTestName ? `${selectedGroupName} - ${selectedTestName}` : (selectedGroupName || selectedTestName)) || '',
                        serviceLabCode: name === 'serviceLabCode' ? val : selectedTestCode || selectedGroupCode || '',
                        serviceLabTestId: name === 'serviceLabCode' || name === 'serviceLabName' ? (selectedTestId || null) : '',
                        serviceLabGrpId: name === 'serviceLabCode' || name === 'serviceLabName' ? (selectedGrpId || null) : '',
                        // serviceLabHead: selectedDeptForTest?.dept_name || '',
                        // serviceLabHeadCode: selectedDeptForTest?.dept_code || '',
                        // serviceLabDeptId: selectedDeptForTest?.dept_id,
                        // serviceLabHeadId: selectedDeptForTest?.service_head_id || null,
                        serviceLabDetailId: selectedDetailId || null,
                        serviceSearchCode: '',
                        serviceSearchName: '',
                        isHospital: val?.service_details_id ? val?.is_hospital : false,
                    };
                    val?.service_details_id && setSharable(val?.is_sharable)
                    !(val?.service_details_id) && setSharable(false)
                    if (updatedState?.serviceLabName) {
                        setenableOthers(true)
                    } else {
                        clearFunction('service')
                    }
                } else {
                    updatedState = { ...updatedState, [name]: val };
                }
                break;
        }
        if (!val) {
            return
        } else {
            setFormState(updatedState);
        }
    };

    const [temp, setTemp] = useState({ serviceCharge: '', doctorShareRupee: '', doctorSharePercent: '', hospitalShareRupee: '', hospitalSharePercent: '' })

    const onChangeHandler = (e, name) => {
        let { value } = e.target;

        const isNumericField = ["serviceCharge", "doctorShareRupee", "doctorSharePercent", "hospitalShareRupee", "hospitalSharePercent", "reviewCount", "intervalAmount"].includes(name);

        if (isNumericField) {
            value = value.replace(/[^0-9 .]/g, "");  // Remove non-numeric characters execpt decimal point
            value = value.replace(/^0+/, "");        // Remove leading zeros

            // Prevent multiple decimals
            if ((value.match(/\./g) || []).length > 1) {
                return;
            }

            // Restrict decimal values to 2 digits
            if (value.includes(".")) {
                const [integer, decimal] = value.split(".");
                if (decimal.length > 2) {
                    return;  // Prevent typing more than 2 digits after decimal
                }
            }

            // Cap percentages at 100%
            if (name.includes("Percent")) {
                const numValue = parseFloat(value);
                if (!isNaN(numValue) && numValue > 100) {
                    value = "100";
                }
            }
        }

        // Update state with sanitized value
        let updatedState = { ...formState, [name]: value || "" };
        let updatedTemp = { ...temp, [name]: value || "" };

        const serviceCharge = parseFloat(updatedState.serviceCharge) || 0;

        updatedTemp.serviceCharge = serviceCharge // temp state for updating the accurate percentage values in temp

        if (name === "serviceCharge") {
            updatedState = {
                ...updatedState,
                doctorShareRupee: "",
                doctorSharePercent: "",
                hospitalShareRupee: "",
                hospitalSharePercent: ""
            };

            updatedTemp = {
                ...updatedTemp,
                doctorShareRupee: "",
                doctorSharePercent: "",
                hospitalShareRupee: "",
                hospitalSharePercent: ""
            };
        }

        if (serviceCharge > 0) {
            const doctorRupee = parseFloat(updatedState.doctorShareRupee) || 0;
            const hospitalRupee = parseFloat(updatedState.hospitalShareRupee) || 0;
            const doctorPercent = parseFloat(updatedState.doctorSharePercent) || 0;
            const hospitalPercent = parseFloat(updatedState.hospitalSharePercent) || 0;
            
            
            // Handle share recalculations dynamically
            if (name === "doctorShareRupee") {
                const doctorShare = Math.min(doctorRupee, serviceCharge);
                const doctorPercent = (doctorShare / serviceCharge) * 100;

                const hospitalShare = serviceCharge - doctorShare;
                const hospitalPercent = (hospitalShare / serviceCharge) * 100;

                // Temp states update for doc share
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
                
                updatedState.doctorShareRupee = value > serviceCharge ? serviceCharge : value
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2)
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)
    
            } else if (name === "hospitalShareRupee") {
                const hospitalShare = Math.min(hospitalRupee, serviceCharge);
                const hospitalPercent = (hospitalShare / serviceCharge) * 100;
    
                const doctorShare = serviceCharge - hospitalShare;
                const doctorPercent = (doctorShare / serviceCharge) * 100;

                  // Temp states update for hos share 
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;
    
                updatedState.hospitalShareRupee = value > serviceCharge ? serviceCharge : value
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2)
                updatedState.doctorShareRupee = (doctorShare).toFixed(2)
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2)
    
            } else if (name === "doctorSharePercent") {
                const docPercent = Math.min(parseFloat(value) || 0, 100);
                const doctorShare = (serviceCharge * docPercent) / 100;
    
                const hospitalShare = serviceCharge - doctorShare;
                const hospitalPercent = (hospitalShare / serviceCharge) * 100;

                  // Temp states update for doc percent
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = docPercent;
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospitalPercent;
    
                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = value; 
                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = (hospitalPercent).toFixed(2);
    
            } else if (name === "hospitalSharePercent") {
                const hospPercent = Math.min(parseFloat(value) || 0, 100);
                const hospitalShare = (serviceCharge * hospPercent) / 100;

                const doctorShare = serviceCharge - hospitalShare;
                const doctorPercent = (doctorShare / serviceCharge) * 100;

                  // Temp states update for hos percent
                updatedTemp.hospitalShareRupee = hospitalShare;
                updatedTemp.hospitalSharePercent = hospPercent;
                updatedTemp.doctorShareRupee = doctorShare;
                updatedTemp.doctorSharePercent = doctorPercent;

                updatedState.hospitalShareRupee = (hospitalShare).toFixed(2);
                updatedState.hospitalSharePercent = value;
                updatedState.doctorShareRupee = (doctorShare).toFixed(2);
                updatedState.doctorSharePercent = (doctorPercent).toFixed(2);
            }
        }

        // Update both states
        setTemp(updatedTemp);
        setFormState(updatedState);
    };






    const textBox = (label, name, val, width, disable = false, Symbol = null) => {
        let isPercentageField = ["doctorSharePercent", "hospitalSharePercent"].includes(name);

        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable || (!formState.serviceCharge && ["doctorShareRupee", "hospitalShareRupee", "doctorSharePercent", "hospitalSharePercent"].includes(name)) || (name === "intervalAmount" && formState.selectedUnit == 'Nos')}
                    value={val !== "" ? val : '0'}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    InputProps={Symbol ? {
                        style: { paddingRight: '0.5vw' },
                        endAdornment:
                            Symbol === 'rupee' ?
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>{CurrencySymbol}</Typography> :
                                <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>%</Typography>
                    } : null}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        );
    };


    const autoComplete = (label, name, val, list, width, disabled = false) => {
        return (
            <Box>
                <Autocomplete
                    freeSolo={((formState?.department === "LAB" || formState?.department === "RADIOTHERAPY" || name == "department" || name == "serviceConsultant" || name == 'selectedDoctorId' || name == 'selectedWardId' || name == 'intervalTime') ? false : true)}
                    clearIcon
                    size="small"
                    options={list || []}
                    name={name}
                    key={`${name}_${val ? 'filled' : 'empty'}_${formResetKey}`}
                    disabled={disabled || (name === "intervalTime" && formState.selectedUnit === 'Nos') || (label === "Ward" && (formState?.department !== 'IP' && formState?.department !== 'IP_OP'))}
                    getOptionLabel={(option) => {
                        if (!option) return "";
                        if (typeof option === 'string') {
                            if (label === 'Module*') {
                                const moduleMapping = {
                                    IP: "IN PATIENT",
                                    OP: "OUT PATIENT",
                                    IP_OP: "BOTH IP & OP",
                                    LAB: "LABORATORY"
                                };
                                return moduleMapping[option] || option;
                            }
                            return option;
                        }
                        if (typeof option !== "object") return "";
                        switch (label) {
                            case 'Doctor': return option?.doctor_name || '';
                            case 'Ward': return option?.ward_name || '';
                            case 'Service Head Code': return option?.service_head_code || '';
                            case 'Service Head*': return option?.head_name || '';
                            case 'Service Code': return option?.service_code || '';
                            case 'Service Name*': return (formState?.department === "LAB" ? (option?.grp_name && option?.test_name ? (`${option?.grp_name} - ${option?.test_name}`) : (option?.grp_name || option?.test_name)) : option?.service_name || '');
                            case 'Consultant Name*': return option?.doctor_name || ''
                            default: return "";
                        }
                    }}
                    value={val ? val : null}
                    onKeyDown={(e) => {
                        if (name === "intervalTime") {
                            const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
                            if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
                                e.preventDefault();
                            }
                        }
                    }}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    onInputChange={(e, newInputValue, reason) => {
                        const maxLength = fieldLimits[name] || 100;
                        if (reason === 'input' && (name == "department" || name == 'selectedDoctorId' || name == 'selectedWardId' || name == 'intervalTime' || name === 'serviceSearchHead')) {
                            e.preventDefault();
                        }
                        if ((newInputValue.length <= maxLength) && reason === 'input' && (formState?.department !== "LAB" || (formState?.department === "LAB" && name === 'serviceLabCode'))) {
                            let trimmedValue = newInputValue?.trim() || ''
                            if (trimmedValue || trimmedValue == '') {
                                if (name === 'serviceSearchHeadCode') {
                                    if (!trimmedValue) {
                                        clearFunction('head')
                                    } else {
                                        formState?.serviceSearchHead && setenableService(true)
                                        setFormState((prevState) => ({
                                            ...prevState,
                                            serviceHeadCode: null,
                                            serviceHead: null,
                                            serviceCode: null,
                                            serviceName: null,
                                            serviceHeadId: null,
                                            serviceNameId: null,
                                            serviceCodeData: [],
                                            serviceNameData: [],
                                            serviceSearchHeadCode: trimmedValue
                                        }));
                                    }
                                } else if (name === 'serviceSearchHead') {
                                    if (!trimmedValue) {
                                        clearFunction('head')
                                    } else {
                                        setConsultation(false)
                                        setactiveByHead(true)
                                        setactiveByName(true)
                                        setactiveByCharge(true)
                                        setisMobileService(false)
                                        if (formState?.serviceHead?.id) {
                                            setenableService(true)
                                            setFormState((prevState) => ({
                                                ...prevState,
                                                serviceHeadCode: null,
                                                // serviceHead: null,
                                                serviceCode: null,
                                                serviceName: null,
                                                serviceHeadId: null,
                                                serviceNameId: null,
                                                serviceCodeData: [],
                                                serviceNameData: [],
                                                serviceSearchHead: trimmedValue
                                            }));
                                        } else {
                                            setenableService(true)
                                            setFormState((prevState) => ({
                                                ...prevState,
                                                serviceHeadCode: null,
                                                serviceHead: null,
                                                serviceCode: null,
                                                serviceName: null,
                                                serviceHeadId: null,
                                                serviceNameId: null,
                                                serviceCodeData: [],
                                                serviceNameData: [],
                                                serviceSearchHead: trimmedValue
                                            }));
                                        }
                                    }
                                } else if (name === 'serviceSearchCode') {
                                    if (!trimmedValue) {
                                        clearFunction('service')
                                    } else {
                                        // formState?.serviceSearchName && setenableOthers(true)
                                        setFormState((prevState) => ({
                                            ...prevState,
                                            serviceCode: null,
                                            serviceName: null,
                                            serviceSearchCode: trimmedValue,
                                        }));
                                    }
                                } else if (name === 'serviceSearchName') {
                                    if (!trimmedValue) {
                                        clearFunction('service')
                                    } else {
                                        // seteditUnit(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : true)
                                        // seteditAmount(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : true)
                                        // seteditDiscount(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : true)
                                        setSharable(false)
                                        if (formState?.serviceName?.id) {
                                            setenableOthers(false)
                                            setFormState((prevState) => ({
                                                ...prevState,
                                                serviceCode: null,
                                                serviceName: null,
                                                serviceNameId: null,
                                                gstPercentage: '',
                                                isHospital: false,
                                                selectedUnit: 'Nos',
                                                selectedTime: null,
                                                serviceSearchName: '',
                                            }));
                                        } else {
                                            setenableOthers(true)
                                            setFormState((prevState) => ({
                                                ...prevState,
                                                serviceCode: null,
                                                serviceName: null,
                                                serviceNameId: null,
                                                gstPercentage: '',
                                                isHospital: false,
                                                selectedUnit: 'Nos',
                                                selectedTime: null,
                                                serviceSearchName: trimmedValue,
                                            }));
                                        }
                                    }
                                    // }else if(name == "serviceConsultant"){
                                    //     if (trimmedValue) {
                                    //         setenableOthers(true)
                                    //         setFormState((prevState) => ({
                                    //             ...prevState,
                                    //             [name]: trimmedValue
                                    //         }));
                                    //     } else {
                                    //         setFormState((prevState) => ({
                                    //             ...prevState,
                                    //             [name]: trimmedValue
                                    //         }));
                                    //     }
                                } else {
                                    if (name === 'serviceLabCode' && formState?.serviceLabName && trimmedValue) {
                                        setenableOthers(true)
                                        setFormState((prevState) => ({
                                            ...prevState,
                                            [name]: trimmedValue
                                        }));
                                    } else {
                                        setFormState((prevState) => ({
                                            ...prevState,
                                            [name]: trimmedValue
                                        }));
                                    }
                                }
                            } else {
                                setFormState((prevState) => ({
                                    ...prevState,
                                    [name]: trimmedValue
                                }));
                            }
                        }
                        else {
                            //  e.preventDefault(); // Prevent extra input if exceeded
                        }
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            // autoFocus
                            // onFocus={(event) => { event.target.select(); event.preventDefault() }}
                            autoFocus={!val && !disabled}
                            onFocus={(event) => {
                                if (!event.target.value) {
                                    event.target.select();
                                }
                            }}
                            disabled={disabled || (name === "intervalTime" && formState.selectedUnit === 'Nos') || (label === "Ward" && (formState?.department !== 'IP' && formState?.department !== 'IP_OP'))}
                            label={label}
                            sx={{ width: width, marginRight: '0.3vw' }}
                        />
                    )}
                />
            </Box>
        );
    };

    const renderGstTextBox = () => {
        const enableGstDiv = formState?.is_gst_enabled ? "block" : "none";
        return (
            <Box component={'div'} display={enableGstDiv}>
                <FormControl sx={{ width: '8.35vw', ml: '0.3vw', mr: "0.3vw" }} size='small'>
                    <InputLabel>GST (%)</InputLabel>
                    <Select
                        label='GST(%)'
                        value={formState.gstPercentage !== null && formState.gstPercentage !== undefined ? formState.gstPercentage : ""}
                        disabled={disbleServiceBasedEdit || !enableOthers}
                        onChange={(e) => {
                            setFormState((prevState) => ({
                                ...prevState,
                                gstPercentage: e.target.value ? +e.target.value : ""
                            }));
                        }}
                    >
                        {gstPercentageConfig?.length > 0 ? (
                            gstPercentageConfig.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem value="" disabled>No Options Available</MenuItem>
                        )}
                    </Select>
                </FormControl>
            </Box>
        )
    }

    const tableView = () => {

        const gridToolBar = () => {
            return (
                <Box>
                    <Box sx={{ position: 'absolute', left: '0', top: '0', display: 'flex', flexDirection: 'row', alignItems: 'center', mt: '0.15vw', ml: '0.25vw' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <Box sx={{ width: "3vw" }}>
                                {delHeadIDs?.length > 0 || delServiceIDs?.length > 0 || delChargeIDs?.length > 0 ? <Button className="eMed_edit_btn_bill" sx={{ ml: "0.75vw" }} onClick={(e) => { handleClick(e) }}>
                                    <Tooltip placement='top' title='Delete' arrow>
                                        <img style={{ height: "1.5vw", width: "1.5vw" }} src={ImagePaths.Delete.default} alt='del' />
                                    </Tooltip>
                                </Button> : null}
                                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} sx={{ top: isAccordionOpen ? '60vh' : '27vh', left: '5.5vw' }}>
                                    <MenuItem onClick={() => handleDeleteOption("head")}>Delete By Head</MenuItem>
                                    <MenuItem onClick={() => handleDeleteOption("service")}>Delete By Name</MenuItem>
                                    <MenuItem onClick={() => handleDeleteOption("charge")}>Delete By Charge</MenuItem>
                                </Menu>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <Autocomplete
                                    options={moduleList}
                                    clearIcon={false}
                                    value={filterdepartment}
                                    getOptionLabel={(option) => {
                                        if (typeof option === 'string') {
                                            const moduleMapping = {
                                                IP: "IN PATIENT",
                                                OP: "OUT PATIENT",
                                                IP_OP: "BOTH IP & OP",
                                                LAB: "LABORATORY"
                                            };
                                            return moduleMapping[option] || option;
                                        }
                                    }}
                                    onChange={(event, value) => {
                                        let selectedModule = originalList[value] || [];
                                        const serviceDetailsArray = selectedModule.flatMap(item =>
                                            item?.service_details.map(service => ({
                                                ...service,
                                                head_name: item.head_name,
                                                service_head_code: item.service_head_code
                                            }))
                                        );
                                        setFilterDepartment(value);
                                        setHeaderList(selectedModule);
                                        setServiceList(serviceDetailsArray);
                                        setFilteredServiceList(serviceDetailsArray);
                                        setFilterHead(null);
                                        setFilterName(null);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Module"
                                            variant="outlined"
                                            size="small"
                                            sx={{ width: "10vw" }}
                                        />
                                    )}
                                />

                                <Autocomplete
                                    options={HeaderList}
                                    clearIcon={false}
                                    value={filterHead}
                                    disabled={!filterdepartment}
                                    getOptionLabel={(option) => option?.head_name}
                                    sx={{ ml: '0.3vw' }}
                                    onChange={(event, value) => {
                                        setFilterHead(value);
                                        if (value) {
                                            const mappedServices = ServiceList.filter(service =>
                                                service.service_head_code === value.service_head_code
                                            );
                                            setFilteredServiceList(mappedServices);
                                        } else {
                                            setFilteredServiceList(ServiceList);
                                        }
                                        setFilterName(null);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Service Head"
                                            variant="outlined"
                                            size="small"
                                            sx={{ width: "12vw" }}
                                            disabled={!filterdepartment}
                                        />
                                    )}
                                />

                                <Autocomplete
                                    options={filteredServiceList}
                                    clearIcon={false}
                                    disabled={!filterdepartment}
                                    getOptionLabel={(option) => option?.service_name}
                                    sx={{ ml: '0.3vw' }}
                                    value={filterName}
                                    onChange={(event, value) => {
                                        if (value) {
                                            setFilterHead(value); setFilterName(value)
                                        } else {
                                            setFilterName(value)
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Service Name"
                                            variant="outlined"
                                            size="small"
                                            sx={{ width: "12vw" }}
                                            disabled={!filterdepartment}
                                        />
                                    )}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <CommonGridToolBarWithExtraFilter />
                    </Box>
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id);

            let selectedRows = departmentData.filter((row) => selectedIDs.has(row.sno));

            let headIDs = new Set();
            let serviceIDs = new Set();
            let chargeIDs = new Set();

            selectedRows.forEach((item) => {
                if (item.service_head_id) headIDs.add(item.service_head_id);
                if (item.service_details_id) serviceIDs.add(item.service_details_id);
                if (item.service_charge_id) chargeIDs.add(item.service_charge_id);
            });

            setDelHeadIDs(Array.from(headIDs));
            setDelServiceIDs(Array.from(serviceIDs));
            setDelChargeIDs(Array.from(chargeIDs));
        };


        departmentData?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 's_no', headerName: 'S.No', flex: 0.02, sortable: false,
                renderCell: (params) => (<Typography fontSize={'0.9vw'}>{params.api.getRowIndex(params.id) + 1}</Typography>)
            },
            {
                field: 'module', headerName: 'Module', flex: 0.10,
                renderCell: (params) => {
                    const moduleValue = params.row?.module === 'IP_OP' ? 'IP & OP' : params.row?.module;
                    return moduleValue ? moduleValue?.length > 15 ? (
                        <Tooltip placement="top" title={moduleValue}>
                            <Typography fontSize={'0.9vw'}>{moduleValue.slice(0, 15) + '...'}</Typography>
                        </Tooltip>
                    ) : (
                        <Typography fontSize={'0.9vw'}>{moduleValue}</Typography>
                    ) : '-';
                }
            },
            {
                field: 'service_head', headerName: 'Service Head Details', flex: 0.18,
                renderCell: (params) => {
                    const head_string = (params.row?.service_head_code ? params.row?.service_head_code + ' - ' : '') + params.row?.service_head
                    return head_string ? (head_string.length > 22) ? (
                        <Tooltip placement="top" title={head_string}><Typography fontSize={'0.9vw'}>{head_string.slice(0, 22) + '...'}</Typography></Tooltip>
                    ) : (
                        <Typography fontSize={'0.9vw'}>{head_string}</Typography>) : '-'

                }
            },
            {
                field: 'service_name', headerName: 'Service Name Details', flex: 0.17,
                renderCell: (params) => {
                    const service_string = (params.row?.service_code ? params.row?.service_code + ' - ' : '') + params.row?.service_name
                    return service_string ? (service_string.length > 21) ? (
                        <Tooltip placement="top" title={service_string}><Typography fontSize={'0.9vw'}>{service_string.slice(0, 21) + '...'}</Typography></Tooltip>
                    ) : (
                        <Typography fontSize={'0.9vw'}>{service_string}</Typography>) : '-'
                }
            },
            {
                field: 'patient_type', headerName: 'Patient Type', flex: 0.10,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.patient_type ? params?.row?.patient_type : '-'}</Box>)
            },
            {
                field: 'doctor_name', headerName: 'Doctor Name', flex: 0.12,
                renderCell: (params) => (params.row?.doctor_name && params.row?.doctor_id ? params.row?.doctor_name?.length > 15 ?
                    <Tooltip placement="top" title={params.row?.doctor_name}><Typography fontSize={'0.9vw'}>{params.row?.doctor_name.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row?.doctor_name}</Typography> : 'All')
            },
            {
                field: 'ward_name', headerName: 'Ward', flex: 0.10,
                renderCell: (params) => (params.row?.ward_name && params.row?.ward_id ? params.row?.ward_name?.length > 15 ?
                    <Tooltip placement="top" title={params.row?.ward_name}><Typography fontSize={'0.9vw'}>{params.row?.ward_name.slice(0, 15) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row?.ward_name}</Typography> : 'All')
            },
            {
                field: 'unit', headerName: 'Unit', flex: 0.08,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.unit ? params?.row?.unit : '-'}</Box>)
            },
            {
                field: 'service_charge', headerName: 'Service Charge', flex: 0.11,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.service_charge ? AmountFormat(params?.row?.service_charge)?.replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: 'doctor_share_amount', headerName: "Doctor's Share", flex: 0.11,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.doctor_share_amount ? AmountFormat(params?.row?.doctor_share_amount)?.replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            {
                field: 'hospital_share_amount', headerName: 'Hospital Share', flex: 0.11,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.hospital_share_amount ? AmountFormat(params?.row?.hospital_share_amount)?.replace(`${CurrencySymbol}`, "") : "0.00"}</Box>)
            },
            ...(commonDisable ? [
                {
                    field: 'action', headerName: 'Action', flex: 0.03,
                    renderCell: (params) => (
                        <Stack direction="row" alignItems="center" spacing={4}>
                            <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                                <CommonEditButton size="1.5vw" onClick={() => {
                                    const data = params.row;
                                    const DocId = doctorList.find(item => item.doctor_id === data?.doctor_id);
                                    const WardId = wardList.find(item => item.ward_id === data?.ward_id);
                                    let Time = data?.interval_time ? (data?.interval_time).split(':') : []
                                    let IntervalTime = data?.interval_time === "01:00:00" ? "60" : Time?.length > 1 ? Time[1] : "0"
                                    let updatedState = {
                                        department: data?.module || '',
                                        selectedDoctorId: DocId,
                                        selectedWardId: WardId,
                                        serviceCharge: data?.service_charge,
                                        selectedUnitValue: 1,
                                        selectedDaysCount: '',
                                        selectedUnit: data?.unit_type,
                                        selectedTime: data?.unit_type === "Hrs" ? data?.unit : null,
                                        doctorShareRupee: data?.doctor_share_amount,
                                        doctorSharePercent: parseFloat(data?.doctor_share_percent).toFixed(2),
                                        doctorSharePercentFull: data?.doctor_share_percent,
                                        hospitalShareRupee: data?.hospital_share_amount,
                                        hospitalSharePercent: parseFloat(data?.hospital_share_percent).toFixed(2),
                                        hospitalSharePercentFull: data?.hospital_share_percent,
                                        intervalTime: IntervalTime,
                                        intervalAmount: data?.interval_amount || 0,
                                        gstPercentage: data?.gst_percent || 0,
                                        is_gst_enabled: JSON.parse(localGetItem("is_gst_enabled")),
                                        reviewDays: data?.review_days || '',
                                        reviewCount: data?.review_count || '',
                                        patientType: data?.patient_type || '',
                                        serviceLabTestId: data?.test_id,
                                        serviceLabGrpId: data?.grp_id,
                                        isHospital: data?.is_hospital,
                                    };
                                    setTemp({
                                        serviceCharge: data.service_charge,
                                        doctorShareRupee: data.doctor_share_amount,
                                        doctorSharePercent: data.doctor_share_percent,
                                        hospitalShareRupee: data.hospital_share_amount,
                                        hospitalSharePercent: data.hospital_share_percent,
                                    })
                                    if (data?.module && data?.module !== "LAB") {
                                        let HeadList = originalList[data?.module] || [];
                                        let uniqueHeadList = HeadList.reduce((acc, current) => {
                                            if (!acc.find(item => item?.service_head_code === current?.service_head_code)) {
                                                acc.push(current);
                                            }
                                            return acc;
                                        }, []);

                                        const serviceDetailsArray = uniqueHeadList?.flatMap(item =>
                                            item?.service_details.map(service => ({
                                                ...service,
                                                head_name: item?.head_name,
                                                service_head_code: item?.service_head_code
                                            }))
                                        );

                                        let uniqueServiceDetailsArray = serviceDetailsArray.reduce((acc, current) => {
                                            if (!acc.find(item => item?.service_code === current?.service_code)) {
                                                acc.push(current);
                                            }
                                            return acc;
                                        }, []);

                                        updatedState = {
                                            ...updatedState,
                                            serviceHeadCodeData: uniqueHeadList,
                                            serviceHeadData: uniqueHeadList,
                                            serviceCodeData: uniqueServiceDetailsArray,
                                            serviceNameData: uniqueServiceDetailsArray,
                                            serviceHeadCode: data?.service_head_code || '',
                                            serviceHead: data?.service_head || '',
                                            serviceCode: data?.service_code || '',
                                            serviceName: data?.service_name || '',
                                            serviceHeadId: data?.service_head_id,
                                            serviceNameId: data?.service_details_id,
                                        };
                                    } else if (data.module === "LAB") {
                                        // let selectedGroupName = null;
                                        // let selectedTestName = null;
                                        // let selectedTestCode = null;
                                        // let selectedGroupCode = null;
                                        // let selectedDeptForTest = null;
                                        // let selectedTestId = null;
                                        // let selectedGrpId = null;
                                        // let selectedDetailId = null;
                                        // let serviceHeadId= null;
                                        // let serviceNameId= null;

                                        // const selectedGroupTest = groupTestDetailsState.find(({ grp_name, test_name }) =>
                                        //     data.service_name === `${grp_name} - ${test_name}` || data.service_name === test_name
                                        // );

                                        // if (selectedGroupTest) {
                                        //     selectedTestName = selectedGroupTest.test_name;
                                        // }

                                        // const matchingTest = deptListState.flatMap(dept => dept.service_details).find(test =>
                                        //     test.service_code === data.service_code || test.test_name === selectedTestName
                                        // );

                                        // if (matchingTest) {
                                        //     selectedTestCode = matchingTest.service_code;
                                        //     selectedTestName = matchingTest.test_name;
                                        //     selectedGroupName = matchingTest.grp_name;
                                        //     selectedGroupCode = matchingTest.grp_service_code;
                                        //     selectedTestId = matchingTest.test_id;
                                        //     selectedGrpId = matchingTest.grp_id;
                                        //     selectedDetailId = matchingTest.service_details_id;
                                        //     serviceHeadId= data.service_head_id;
                                        //     serviceNameId= data.service_details_id;
                                        // }

                                        // selectedDeptForTest = deptListState.find(dept =>
                                        //     dept.service_details?.some(test =>
                                        //         test.test_name === selectedTestName || test.service_code === selectedTestCode
                                        //     )
                                        // );

                                        updatedState = {
                                            ...updatedState,
                                            serviceLabName: data.service_name || '',
                                            serviceLabCode: data.service_code || '',
                                            serviceLabHead: data.service_head || '',
                                            serviceLabHeadCode: data.service_head_code || '',
                                            serviceLabTestId: data?.test_id || null,
                                            serviceLabGrpId: data?.grp_id || null,
                                            serviceLabDeptId: data?.dept_id || null,
                                            serviceLabHeadId: data?.service_head_id || null,
                                            serviceLabDetailId: data.service_details_id || null,
                                            serviceHeadId: data.service_head_id || null,
                                            serviceNameId: data.service_details_id || null
                                        };
                                    }
                                    setFormState(updatedState);
                                    setConsultation(data.is_consultation || false);
                                    data?.is_consultation && setdisableDoc(true)
                                    setSharable(data.is_sharable || false);
                                    seteditUnit(data.edit_unit || false);
                                    seteditAmount(data.edit_amount || false);
                                    seteditDiscount(data.edit_discount || false);
                                    setactiveByHead(data.active_by_service_head || false);
                                    setactiveByName(data.active_by_service_name || false);
                                    setactiveByCharge(data.is_active || false);
                                    setisMobileService(data.is_mobile_service || false);
                                    setEditID(data);
                                    setEditMode(true);
                                    setdisbleServiceBasedEdit(true)
                                    // setenableHead(true)
                                    // setenableService(true)
                                    setenableOthers(true)
                                    setIsAccordionOpen(true);
                                }} />
                            </Stack>
                        </Stack>)
                }
            ] : [])
        ]
        return (
            <Box sx={{ height: isAccordionOpen ? '38vh' : '70.5vh', marginTop: isAccordionOpen ? '-.5vw' : '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false}
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={departmentData}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    getRowClassName={(params) => {
                        if (params.row.active_by_service_head === false && params.row.module !== "RADIOTHERAPY") {
                            return 'gray-row-all';
                        }
                        if (params.row.active_by_service_head === true && params.row.active_by_service_name === false && params.row.module !== "RADIOTHERAPY") {
                            return 'gray-row-except-service-head';
                        }
                        if (params.row.active_by_service_head === true && params.row.active_by_service_name === true && params.row.is_active === false && params.row.module !== "RADIOTHERAPY") {
                            return 'gray-row-except-service-head-service-name';
                        }
                        return '';
                    }}
                    sx={{
                        "& .gray-row-all .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row-all .MuiDataGrid-cell[data-field='module'], & .gray-row-all .MuiDataGrid-cell[data-field='action']": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row-except-service-head .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row-except-service-head .MuiDataGrid-cell[data-field='module'], & .gray-row-except-service-head .MuiDataGrid-cell[data-field='action'], & .gray-row-except-service-head .MuiDataGrid-cell[data-field='service_head']": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .gray-row-except-service-head-service-name .MuiDataGrid-cell": {
                            backgroundColor: "#e8e7e7 !important",
                            color: "black !important",
                        },
                        "& .gray-row-except-service-head-service-name .MuiDataGrid-cell[data-field='module'], & .gray-row-except-service-head-service-name .MuiDataGrid-cell[data-field='action'], & .gray-row-except-service-head-service-name .MuiDataGrid-cell[data-field='service_head'], & .gray-row-except-service-head-service-name .MuiDataGrid-cell[data-field='service_name']": {
                            backgroundColor: "white !important",
                            color: "black !important",
                        },
                        "& .MuiDataGrid-cell:nth-child(1)": {
                            backgroundColor: "white !important",
                        }
                    }}
                    page={page}
                    pageSize={pageSize}
                    onPageChange={(newPage) => { setPage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setPageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setisDelete(false);
        setCheckBoxList([])
        setDelHeadIDs([])
        setDelServiceIDs([])
        setDelChargeIDs([])
    }

    const clearFunction = (emptyType = '') => {
        setFormResetKey((k) => k + 1)
        setFormState(prevState => ({
            department: (emptyType === 'head' || emptyType === 'service') ? prevState.department : null,
            serviceHeadCodeData: (emptyType === 'head' || emptyType === 'service') ? prevState.serviceHeadCodeData : [],
            serviceHeadData: (emptyType === 'head' || emptyType === 'service') ? prevState.serviceHeadData : [],
            serviceCodeData: emptyType === 'service' ? prevState.serviceCodeData : [],
            serviceNameData: emptyType === 'service' ? prevState.serviceNameData : [],
            serviceHeadCode: emptyType === 'service' ? prevState.serviceHeadCode : '',
            serviceHead: emptyType === 'service' ? prevState.serviceHead : '',
            serviceHeadId: emptyType === 'service' ? prevState.serviceHeadId : null,
            serviceNameId: null,
            serviceCode: '',
            serviceName: '',
            serviceLabHeadCode: emptyType === 'service' ? prevState.serviceLabHeadCode : null,
            serviceLabHead: emptyType === 'service' ? prevState.serviceLabHead : null,
            serviceLabCode: '',
            serviceLabName: null,
            patientType: 'All',
            serviceSearchHeadCode: emptyType === 'service' ? prevState.serviceSearchHeadCode : '',
            serviceSearchHead: emptyType === 'service' ? prevState.serviceSearchHead : '',
            serviceLabDeptId: emptyType === 'service' ? prevState.serviceLabDeptId : '',
            serviceLabHeadId: emptyType === 'service' ? prevState.serviceLabHeadId : '',
            serviceLabDetailId: null,
            serviceSearchCode: '',
            serviceSearchName: '',
            selectedDoctorId: doctorList[0],
            selectedWardId: wardList[0],
            serviceCharge: '',
            selectedUnitValue: 1,
            selectedDaysCount: '',
            selectedUnit: 'Nos',
            selectedTime: null,
            doctorShareRupee: '',
            doctorSharePercent: '',
            doctorSharePercentFull: '',
            hospitalShareRupee: '',
            hospitalSharePercent: '',
            hospitalSharePercentFull: '',
            intervalTime: null,
            intervalAmount: 0,
            reviewDays: '',
            reviewCount: '',
            gstPercentage: '',
            serviceLabTestId: null,
            serviceLabGrpId: null,
            additionalDetailId: null,
            additionalHeadId: null,
            is_gst_enabled: JSON.parse(localGetItem("is_gst_enabled")),
            isHospital: false
        }))
        setConsultation(false)
        setSharable(false)
        seteditUnit(true)
        seteditAmount(true)
        seteditDiscount(true)
        setEditID(null)
        setisDelete(false);
        setCheckBoxList([])
        setDelHeadIDs([])
        setDelServiceIDs([])
        setDelChargeIDs([])
        setEditMode(false)
        setDeleteMethod('')
        setdisableDoc(false)
        setisMobileService(false)
        setdisbleServiceBasedEdit(false)
        if (emptyType == 'head') {
            setenableService(false)
            setenableOthers(false)
            setactiveByHead(true)
            setactiveByName(true)
            setactiveByCharge(true)
        } else if (emptyType == 'service') {
            setenableOthers(false)
        } else {
            setenableHead(false)
            setenableService(false)
            setenableOthers(false)
        }
    }

    const addDepartmentDetails = (isAddCharges = false) => {
        try {
            // if (
            //     !formState?.patientType
            //      || !formState?.department ||
            //     (!((formState?.serviceSearchHead) || (formState.serviceHead?.head_name) || (formState?.serviceLabHead) || (formState.serviceHead))) ||

            //     (!formState?.serviceSearchName && !formState.serviceName?.service_name && !formState.serviceLabName && !formState.serviceName) ||

            //     (formState?.selectedUnit === "Hrs" && !formState?.intervalTime) || (formState?.selectedUnit === "Hrs" && !formState?.intervalAmount) ||

            //     ((Sharable && formState?.serviceCharge) && (!formState?.doctorSharePercent && !formState?.doctorShareRupee && !formState?.hospitalSharePercent && !formState?.hospitalShareRupee))) {
            //     return errorMessage('Please Enter All mandatory fields')
            // } 
            if (!formState?.department) {
                return errorMessage('Select Module')
            }
            else if (!formState?.patientType) {
                return errorMessage('Select Patient Type')
            }
            else if (!((formState?.serviceSearchHead) || (formState.serviceHead?.head_name) || (formState?.serviceLabHead) || (formState.serviceHead))) {
                return errorMessage('Select Service Head')
            }
            else if ((!formState?.serviceSearchName && !formState.serviceName?.service_name && !formState.serviceLabName && !formState.serviceName)) {
                return errorMessage('Select Service Name')
            }
            else if ((formState?.selectedUnit === "Hrs" && !formState?.selectedTime) || ((formState?.selectedUnit === "Hrs" && !formState?.intervalTime) || (formState?.selectedUnit === "Hrs" && !formState?.intervalAmount))) {
                return errorMessage('Select Time')
            } else if ((Sharable && formState?.serviceCharge) && (!formState.doctorSharePercent || !formState.doctorShareRupee || !formState.hospitalSharePercent || !formState.hospitalShareRupee)) {
                return errorMessage('Please Enter Doctor or Hospital Share')
            } else if (formState?.serviceName == '' || null) {
                return errorMessage('Please Enter Service Name')
            } else if (formState?.serviceHeadCode == '' || null) {
                return errorMessage('Please Enter Service Head')
            }
            var serviceLabName = (formState?.serviceLabName?.test_name && formState?.serviceLabName?.grp_name) ? `${formState?.serviceLabName?.grp_name} - ${formState?.serviceLabName?.test_name}` : formState?.serviceLabName?.grp_name ? formState?.serviceLabName?.grp_name : formState?.serviceLabName
            var data = []

            let RTheadID = null
            if (formState?.department === 'RADIOTHERAPY') {
                const match = departmentData?.find((item) => item?.module === 'RADIOTHERAPY' && item?.service_head ===(formState?.serviceHead?.head_name || formState?.serviceHead || formState?.serviceSearchHead));
                RTheadID = match?.service_head_id || null;
            }

            data = {
                "module_type": formState.department,
                "service_head_code": formState.department === "LAB" ? formState?.serviceLabHeadCode : (formState?.serviceSearchHeadCode || formState.serviceHeadCode?.service_head_code || (formState?.serviceHeadCode?.trim() ?? '')),
                "service_head": formState.department === "LAB" ? formState?.serviceLabHead : ((formState?.serviceHead?.head_name?.trim() ?? '') || (formState?.serviceHead ?? '') || (formState?.serviceSearchHead?.trim() ?? '')),
                "service_code": formState.department === "LAB" ? formState?.serviceLabCode : (formState?.serviceSearchCode || formState.serviceCode?.service_code || (formState?.serviceCode ?? '')),
                "service_name": formState.department === "LAB" ? serviceLabName : ((formState?.serviceName?.service_name?.trim() ?? '') || (formState?.serviceName?.trim() ?? '') || (formState?.serviceSearchName?.trim() ?? '')),
                "patient_type": formState?.patientType,
                "doctor_id": formState.selectedDoctorId?.doctor_id || null,
                "ward_id": formState.department === "IP" || formState.department === "IP_OP" ? formState.selectedWardId?.ward_id : null,
                "service_charge": formState.serviceCharge ? parseInt(formState.serviceCharge) : 0,
                "unit": formState.selectedUnit === "Hrs" ? (formState.selectedTime.includes(":") && formState.selectedTime.split(":")?.length === 3
                    ? formState.selectedTime : `${formState.selectedTime}:00`) : formState.selectedUnit === "Days" ? parseFloat(formState.selectedDaysCount) : formState.selectedUnitValue,
                "unit_type": formState.selectedUnit,
                "interval_time": formState.selectedUnit == "Hrs" ? formState?.intervalTime == 60 ? "01:00:00" : `00:${formState.intervalTime}:00` : null,
                "interval_amount": formState.selectedUnit == "Hrs" ? (formState.intervalAmount) : 0,
                "doctor_share_percent": formState.doctorSharePercent ? Number(temp.doctorSharePercent) : 0,
                "hospital_share_percent": formState.hospitalSharePercent ? Number(temp.hospitalSharePercent) : 0,
                "doctor_share_amount": formState.doctorShareRupee ? Number(temp.doctorShareRupee) : 0,
                "hospital_share_amount": formState.hospitalShareRupee ? Number(temp.hospitalShareRupee) : 0,
                "edit_unit": editUnit,
                "edit_amount": editAmount,
                "edit_discount": editDiscount,
                "active_by_service_head": activeByHead,
                "active_by_service_name": activeByName,
                "is_active": activeByCharge,
                "is_mobile_service": isMobileService,
                "charge_type": 'Normal',
                'gst_percent': formState.gstPercentage || 0,
                'review_days': formState.reviewDays || 0,
                'review_count': formState.reviewCount || 0,
                'is_consultation': consultation,
                'is_sharable': Sharable,
                'is_hospital': formState.isHospital,
                'service_head_id': RTheadID ? RTheadID : formState?.additionalHeadId ? formState?.additionalHeadId : (formState?.serviceHead?.id || formState?.serviceHeadId || formState?.serviceLabHeadId) ? (formState?.serviceHead?.id || formState?.serviceHeadId || formState?.serviceLabHeadId) : (formState?.serviceSearchHead || formState?.serviceSearchHeadCode) && null,
                'service_details_id': formState?.additionalDetailId ? formState?.additionalDetailId : (formState?.serviceName?.id || formState?.serviceNameId || formState?.serviceLabDetailId) ? (formState?.serviceName?.id || formState?.serviceNameId || formState?.serviceLabDetailId) : (formState?.serviceSearchCode || formState?.serviceSearchName) && null,
                'grp_id': formState.department === "LAB" ? formState?.serviceLabGrpId : null,
                'test_id': formState.department === "LAB" ? formState?.serviceLabTestId : null,
                'dept_id': formState.department === "LAB" ? formState?.serviceLabDeptId : null,
                ...(EditID && { service_charge_id: EditID?.service_charge_id })
            }

            setisloader(true)
            RestAPIService.create(data, Serviceurls.NEW_DEPARTMENT_MASTER)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getDepartmentData()
                        setisloader(false)
                        const resetFormState = {
                            // selectedDoctorId: doctorList[0],
                            selectedWardId: wardList[0],
                            serviceCharge: '',
                            selectedUnitValue: 1,
                            selectedDaysCount: '',
                            // selectedUnit: 'Nos',
                            // selectedTime: null,
                            doctorShareRupee: '',
                            doctorSharePercent: '',
                            doctorSharePercentFull: '',
                            hospitalShareRupee: '',
                            hospitalSharePercent: '',
                            hospitalSharePercentFull: '',
                            intervalTime: null,
                            intervalAmount: 0,
                            reviewDays: '',
                            reviewCount: '',
                            // gstPercentage: '',
                            // patientType: 'All',
                            // isHospital: false,
                            ...(isAddCharges && {
                                additionalHeadId: response.data?.service_head_id,
                                additionalDetailId: response.data?.service_details_id,
                            }),
                            ...(!isAddCharges && {
                                gstPercentage: '',
                                patientType: 'All',
                                isHospital: false,
                                selectedUnit: 'Nos',
                                selectedDoctorId: doctorList[0],
                                selectedTime: null,
                            })
                        };
                        // !isAddCharges && seteditUnit(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : true)
                        // !isAddCharges && seteditAmount(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : true)
                        // !isAddCharges && seteditDiscount(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "CANTEEN" ? false : true)
                        setactiveByHead(true)
                        getModuleList()
                        setactiveByName(true)
                        setactiveByCharge(true)
                        setEditID(null)
                        setFilterHead(null)
                        setFilterName(null)
                        setFilterDepartment(null)
                        setEditMode(false)
                        setFormState({ ...formState, ...resetFormState });
                        if (isAddCharges) {
                            setdisbleServiceBasedEdit(true)
                            setenableHead(false)
                            setenableService(false)
                        } else {
                            clearFunction();
                            setConsultation(false)
                            setSharable(false)
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteServiceData = () => {
        try {
            setisloader(true)
            let ID = deleteMethod === "head" ? delHeadIDs : deleteMethod === "service" ? delServiceIDs : delChargeIDs;
            let data = {
                "id": ID,
                "delete_by": deleteMethod,
                "action_from": "master",
                "submit_action": submitAction,
            }
            if (submitAction === 'yes') {
                data.flag = submitFlag;
            }
            RestAPIService.delete(`${Serviceurls.NEW_DEPARTMENT_MASTER}`, data)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        getDepartmentData()
                        getModuleList();
                        closeFilter();
                        clearFunction();
                        handleModalClose();
                    }
                    if (response?.data?.status === 'fail' && response.data.message === "Delete operation can't be done mentioned areas where linked with this service") {
                        setSubmitFlag(response?.data?.flag);
                        setSubmitMessage(response?.data?.message);
                        setlinkedModule(response?.data?.data);
                        setDeleteModal(true);
                        setisDelete(false);
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const handleModalClose = () => {
        setisloader(false)
        setDeleteModal(false);
        setSubmitFlag({});
        setSubmitMessage('');
        setlinkedModule({})
        setSubmitAction('no');
    }

    const handleModalsubmit = () => {
        setSubmitAction('yes');
    }

    useEffect(() => {
        if (submitAction === 'yes') {
            deleteServiceData();
        }
    }, [submitAction]);

    const getHeadCounsultationList = () => {
        try {
            setisloader(false)
            let headId = formState?.serviceHead?.id ? formState?.serviceHead?.id : ''
            RestAPIService.getAll(Serviceurls.HEAD_CONSULTATION_LIST + '?id=' + headId)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const Data = response.data.data || [];
                        setheadConsultData(Data)
                        setConsultation(true)
                        setisloader(false)
                        setFormState((prevstate) => ({
                            ...prevstate,
                            serviceName: null,
                            serviceSearchName: ""
                        }))
                    }
                }).catch((error) => {
                    setisloader(false)
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (e) {

        }
    }

    const openDeleteModal = () => {
        let width = "45vw"
        let height = null
        let testID = "test"
        return (
            <Modal open={deleteModal}>
                <Paper elevation={3} id="emedhub_popup_mainBox" sx={{ width: width, height: height }}>
                    <div id="emedhub_popup_header" style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                        <Stack direction="row" spacing={2} alignItems={"center"}>
                            <Typography sx={{ color: "#616161", fontWeight: 600 }}>{"Do you really want to delete all configurations associated with the selected service ?"}</Typography>
                        </Stack>
                        <IconButton emed_tid={`deptm_dlt_close`} onClick={() => { handleModalClose() }} size="small" ><img className="eMed_DeletePopup_CrossIcon" src={ImagePaths.LabCloseButton.default} alt={"close"} /></IconButton>
                    </div>
                    <h2 style={{ marginLeft: "1.5dvw" }}>Linked Configurations :</h2>
                    <div id="emedhub_popup_content" emed_tid={`deptm_${testID}_cnt`} style={{ display: "block", marginLeft: "5dvw" }} >
                        {linkedModule?.map((value, index) => (
                            <div key={index}>
                                {index + 1}. {value}
                            </div>
                        ))
                        }
                    </div>
                    <Stack id="emedhub_popup_footer" direction="row" justifyContent={"flex-end"} alignItems="center" sx={{ height: "3vw" }}>
                        <div>
                            <Button emed_tid={`deptm_dlt_yes`} size="small" sx={{ marginRight: "1vw", textTransform: "capitalize" }} variant='contained' color='error' onClick={() => { handleModalsubmit() }}>{"Yes"}</Button>
                            <Button emed_tid={`deptm_dlt_no`} size="small" sx={{ textTransform: "capitalize" }} variant={"outlined"} color='error' onClick={() => { handleModalClose() }}>{"No"}</Button>
                        </div>
                    </Stack>
                </Paper>
            </Modal>
        )
    }
    
    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Accordion expanded={isAccordionOpen} onChange={() => setIsAccordionOpen(prev => !prev)}>
                <AccordionSummary expandIcon={<ExpandMore />} sx={{ maxHeight: '3vh', '& .MuiAccordionSummary-content': { margin: 1 } }}>
                    <Typography variant="body2" fontWeight="bold">Service Configuration</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ padding: 0, marginTop: '-2.5vh' }}>
                    <Box component={'div'} sx={{ height: '100%', width: '93vw', backgroundColor: 'white', padding: '.6vw' }}>
                        <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                            <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row' }}>
                                {autoComplete("Module*", 'department', formState?.department, moduleList, '15vw', (editMode || formState?.additionalDetailId))}
                                {formState?.department === "LAB" ? autoComplete("Service Head Code", 'serviceLabHeadCode', formState?.serviceLabHeadCode, deptCodesState, '15vw', true) :
                                    autoComplete("Service Head Code", 'serviceSearchHeadCode', formState?.serviceHeadCode, formState?.serviceHeadCodeData, '15vw', true)}
                                {formState?.department === "LAB" ? autoComplete("Service Head*", 'serviceLabHead', formState?.serviceLabHead, deptNamesState, '15vw', (!enableHead)) :
                                    autoComplete("Service Head*", 'serviceSearchHead', formState?.serviceHead, formState?.serviceHeadData, '15vw', (!enableHead))}
                                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", marginRight: "0.25vw", height: '1.5vw', width: "15vw", paddingLeft: "0.5vw" }}>
                                    <Typography sx={{ fontSize: "0.85vw" }}>Service Type</Typography>
                                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start", marginTop: "-0.5vw" }}>
                                        <FormControlLabel control={<Checkbox checked={consultation} onChange={(e) => {
                                            if (e.target.checked) {
                                                getHeadCounsultationList()
                                            } else {
                                                setConsultation(false)
                                                setheadConsultData([])
                                                setFormState((prevState) => ({
                                                    ...prevState,
                                                    serviceName: null,
                                                    serviceSearchName: "",
                                                    selectedDoctorId: null,
                                                }));
                                                setdisableDoc(false)
                                            }

                                        }} size='small' />} disabled={formState?.department === 'LAB' || formState?.department === 'RADIOTHERAPY' || formState?.department === 'RADIOLOGY' || InvestigationList?.includes(formState?.department) || formState?.department === 'CANTEEN' || !enableService || disbleServiceBasedEdit || formState?.serviceHeadId || formState?.serviceHead?.id} label={"Consultation"} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.85rem" } }} />
                                        <FormControlLabel control={<Checkbox checked={Sharable} onChange={(e) => {
                                            setSharable(e.target.checked)
                                            setFormState((prevState) => ({
                                                ...prevState,
                                                doctorSharePercent: '',
                                                doctorSharePercentFull: '',
                                                doctorShareRupee: '',
                                                hospitalSharePercent: '',
                                                hospitalSharePercentFull: '',
                                                hospitalShareRupee: ''
                                            }));
                                            if (!e.target.checked) {
                                                setFormState({ ...formState, isHospital: false })
                                            }
                                        }}
                                            disabled={!enableService || disbleServiceBasedEdit || formState?.department === 'RADIOTHERAPY' }
                                            size='small' />} label={"Sharable"} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.85rem" } }} />
                                    </Box>
                                </Box>
                                {formState?.department === "LAB" ? autoComplete("Service Code", 'serviceLabCode', formState?.serviceLabCode, testCodesState, '15vw', true) :
                                    autoComplete("Service Code", 'serviceSearchCode', formState?.serviceCode, formState?.serviceCodeData, '15vw', true)}
                                {formState?.department === "LAB" ? autoComplete("Service Name*", 'serviceLabName', formState?.serviceLabName, groupTestDetailsState, '15vw', (!enableService)) :
                                    consultation ? autoComplete("Consultant Name*", 'serviceConsultant', formState?.serviceName, headConsultData, '15vw', (!enableService)) :
                                        autoComplete("Service Name*", 'serviceSearchName', formState?.serviceName, formState?.serviceNameData, '15vw', (!enableService) || formState?.serviceHead == '' ? true : false)}
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex' }}>
                                <FormControl sx={{ width: '15vw' }} size='small'>
                                    <InputLabel>Patient Type*</InputLabel>
                                    <Select
                                        label='Patient Type*'
                                        value={formState.patientType}
                                        onChange={(e) => {
                                            setFormState({
                                                ...formState,
                                                patientType: e.target.value,
                                                reviewDays: "",
                                                reviewCount: "",
                                            })
                                        }}
                                        // disabled={(formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "IP" || formState?.department === "CANTEEN"|| !enableOthers )}
                                        disabled={!(formState?.department === "OP")}
                                    >
                                        {patient_type.map(item => (
                                            <MenuItem value={item}>{item}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                {/* {autoComplete("Patient Type*", 'patientType', formState?.patientType, patient_type, '15vw', (formState?.department === "LAB" || formState?.department === "RADIOLOGY" || formState?.department === "IP" || !enableOthers))} */}
                                {autoComplete("Doctor", 'selectedDoctorId', formState?.selectedDoctorId, doctorList, '15vw', (!enableOthers || formState?.department === "CANTEEN" || formState?.department === "RADIOTHERAPY" || disableDoc))}
                                {autoComplete("Ward", 'selectedWardId', formState?.selectedWardId, wardList, '15vw', !enableOthers)}
                                {textBox("Service Charge*", 'serviceCharge', formState?.serviceCharge, '15vw', !enableOthers)}
                                <Box sx={{ display: 'flex' }}>
                                    {formState.selectedUnit === 'Nos' ?
                                        <TextField
                                            value={formState.selectedUnit === 'Nos' ? formState.selectedUnitValue : formState.selectedTime}
                                            disabled={(formState.selectedUnit === 'Nos') || disbleServiceBasedEdit}
                                            size='small'
                                            sx={{ width: '7.35vw', height: '2.5vw' }}
                                        /> : formState.selectedUnit === 'Days' ?
                                            <TextField
                                                value={formState.selectedDaysCount}
                                                size='small'
                                                sx={{ width: '7.35vw', height: '2.5vw' }}
                                                label='Days'
                                                onChange={(e) => {
                                                    let { value } = e.target;
                                                    if (value === "" || /^\d+(\.\d{0,2})?$/.test(value)) {
                                                        setFormState((prevState) => ({
                                                            ...prevState,
                                                            selectedDaysCount: value,
                                                        }));
                                                    }
                                                }}
                                            />
                                            :
                                            <AntdTimePicker
                                                format={'HH:mm'}
                                                style={{ width: '7.35vw', height: '2.5vw' }}
                                                value={formState.selectedTime ? moment(formState.selectedTime, 'hh:mm') : null}
                                                onChange={(time, timeString) => setFormState({ ...formState, selectedTime: timeString })}
                                                disabled={disbleServiceBasedEdit}
                                            />
                                    }
                                    <FormControl sx={{ width: '7.35vw', ml: '0.3vw', mr: "0.3vw" }} size='small'>
                                        <InputLabel>Unit *</InputLabel>
                                        <Select
                                            label='unit'
                                            value={formState.selectedUnit}
                                            disabled={!enableOthers || disbleServiceBasedEdit}
                                            onChange={(e) => { setFormState({ ...formState, selectedUnit: e.target.value, selectedTime: null, selectedMinTime: null, selectedDaysCount: '' }) }}
                                        >
                                            <MenuItem value={'Nos'}>Nos</MenuItem>
                                            <MenuItem disabled={formState?.department === 'LAB' || formState?.department === 'RADIOTHERAPY' || formState?.department === 'RADIOLOGY' || InvestigationList?.includes(formState?.department)} value={'Hrs'}>Hrs</MenuItem>
                                            {/* <MenuItem disabled={formState?.department != 'IP'} value={'Days'}>Days</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </Box>
                                {formState.selectedUnit === 'Hrs' ? autoComplete(`Select Interval Time${formState.selectedUnit === 'Hrs' ? '*' : ''}`, 'intervalTime', formState?.intervalTime, IntervalList, '7.35vw') : null}
                                {formState.selectedUnit === 'Hrs' ? textBox(`Interval Amount${formState.selectedUnit === 'Hrs' ? '*' : ''}`, 'intervalAmount', formState?.intervalAmount, '7.35vw', false) : null}
                                {formState.selectedUnit === 'Hrs' ? null : textBox(Sharable ? "Doctor's Share*" : "Doctor's Share", 'doctorShareRupee', Sharable ? formState?.doctorShareRupee : '', '7.35vw', !Sharable, 'rupee')}
                                {formState.selectedUnit === 'Hrs' ? null : textBox(Sharable ? "Doctor's Percentage*" : "Doctor's Percent", 'doctorSharePercent', Sharable ? formState?.doctorSharePercent : '', '7.35vw', !Sharable, 'percent')}
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex' }}>
                                {formState.selectedUnit === 'Hrs' ? textBox(Sharable ? "Doctor's Share*" : "Doctor's Share", 'doctorShareRupee', Sharable ? formState?.doctorShareRupee : '', '7.35vw', !Sharable, 'rupee') : null}
                                {formState.selectedUnit === 'Hrs' ? textBox(Sharable ? "Doctor's Percent*" : "Doctor's Percent", 'doctorSharePercent', Sharable ? formState?.doctorSharePercent : '', '7.35vw', !Sharable, 'percent') : null}
                                {textBox(Sharable ? "Hospital Share*" : "Hospital Share", 'hospitalShareRupee', Sharable ? formState?.hospitalShareRupee : '', '7.35vw', !Sharable, 'rupee')}
                                {textBox(Sharable ? "Hospital Percent*" : "Hospital Percent", 'hospitalSharePercent', Sharable ? formState?.hospitalSharePercent : '', '7.35vw', !Sharable, 'percent')}
                                {formState?.department !== 'LAB' && formState?.department !== 'RADIOLOGY' && !InvestigationList?.includes(formState?.department) ? renderGstTextBox() : null}
                                {formState?.department !== 'LAB' && formState?.department !== 'RADIOLOGY' && !InvestigationList?.includes(formState?.department) && formState?.department !== 'IP' ?
                                    <Box display="flex" mb="0.5vw" alignItems="center" justifyContent="space-between">
                                        <Autocomplete
                                            size="small"
                                            disablePortal
                                            disabled={(!enableOthers || (formState?.patientType != 'Review Patient'))}
                                            id="combo-box-demo"
                                            options={NumberList}
                                            onChange={(e, newValue) => {
                                                setFormState((prevState) => ({
                                                    ...prevState,
                                                    reviewDays: newValue || "",
                                                    reviewCount: "",
                                                }));
                                            }}
                                            value={formState.reviewDays || ""}
                                            sx={{ width: "15vw", marginRight: "0.2vw" }}
                                            renderInput={(params) => <TextField {...params} label="Review Days" />}
                                        />
                                        {textBox("Visit Count", "reviewCount", formState.reviewCount, "15vw", (!enableOthers || (formState?.patientType != 'Review Patient')), null)}
                                    </Box> : null}
                                <FormControl sx={{ width: '15vw' }} size='small'>
                                    <InputLabel>Overall Concession Based On</InputLabel>
                                    <Select
                                        label='Overall Concession Based On'
                                        value={formState.isHospital}
                                        onChange={(e) => { setFormState({ ...formState, isHospital: e.target.value }) }}
                                        disabled={!Sharable || !enableOthers || disbleServiceBasedEdit}
                                    >
                                        <MenuItem value={false}>Bill Amount</MenuItem>
                                        <MenuItem value={true}>Hospital Share</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex' }}>
                                <FormControlLabel control={<Checkbox checked={editUnit} onChange={(e) => { seteditUnit(e.target.checked) }} size='small' />} disabled={!enableOthers || formState?.department === 'CANTEEN' || formState?.department === 'RADIOTHERAPY' || InvestigationList?.includes(formState?.department)} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }} label={"Edit Unit"} />
                                <FormControlLabel control={<Checkbox checked={editAmount} onChange={(e) => { seteditAmount(e.target.checked) }} size='small' />} disabled={!enableOthers || formState?.department === 'CANTEEN' || formState?.department === 'RADIOTHERAPY' || InvestigationList?.includes(formState?.department)} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }} label={"Edit Amount"} />
                                <FormControlLabel control={<Checkbox checked={editDiscount} onChange={(e) => { seteditDiscount(e.target.checked) }} size='small' />} disabled={!enableOthers || formState?.department === 'CANTEEN' || formState?.department === 'RADIOTHERAPY' || InvestigationList?.includes(formState?.department)} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }} label={"Edit Discount"} />
                                <FormControlLabel control={<Checkbox checked={activeByHead} onChange={(e) => { setactiveByHead(e.target.checked); setactiveByName(e.target.checked); setactiveByCharge(e.target.checked) }} disabled={!editMode || !enableOthers} size='small' />} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }} label={"Active by Service Head"} />
                                <FormControlLabel control={<Checkbox checked={activeByName} onChange={(e) => { setactiveByName(e.target.checked); setactiveByCharge(e.target.checked); }} disabled={!editMode || !enableOthers} size='small' />} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }} label={"Active by Service Name"} />
                                <FormControlLabel control={<Checkbox checked={activeByCharge} onChange={(e) => { setactiveByCharge(e.target.checked) }} disabled={!editMode || !enableOthers} size='small' />} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }} label={"Active by Charge"} />
                                {UserData?.has_telemedicine ? <FormControlLabel control={<Checkbox checked={isMobileService} onChange={(e) => { setisMobileService(e.target.checked) }} disabled={(formState?.department === 'IP_OP' || formState?.department === 'OP') ? false : true } size='small' />} sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.9rem" } }} label={"Is Mobile Service"} /> : null}
                            </Box>
                            <Box sx={{ gap: '1vw', mr: "0.3vw", display: commonDisable ? null : 'none' }}>
                                <Button
                                    className='eMed_New_Ip_Btn'
                                    disabled={editMode || formState?.department === 'RADIOLOGY' || formState?.department === "RADIOTHERAPY" || InvestigationList?.includes(formState?.department)}
                                    startIcon={<AddCircle />}
                                    sx={{ mr: "0.5vw" }}
                                    onClick={() => { addDepartmentDetails(true) }}
                                >
                                    Additional Charge
                                </Button>
                                <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '5vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                                <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '5vw', marginLeft: '1vw' }} onClick={() => { addDepartmentDetails(false) }}>{editMode ? "Update" : "Add"}</Button>
                            </Box>
                        </Box>
                    </Box>
                </AccordionDetails>
            </Accordion>
            <Box component={'div'} sx={{ height: isAccordionOpen ? '38.5vh' : '71vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            {console.log(formState, "formState")}
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this item ?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteServiceData}
                />
                : null}
            {deleteModal &&
                openDeleteModal()
            }
            <Loader loaderOpen={isloader} />
        </Box>
    )
}